/* Collection redesign · compare tray (up to 4 products). Uses event delegation so it keeps working after Focal re-renders the grid on filter/sort/page. */
(function () {
  var MAX = 4;
  var KEY = 'pmc-compare';
  var picked = [];
  try { picked = JSON.parse(sessionStorage.getItem(KEY) || '[]'); } catch (e) { picked = []; }

  function save() { try { sessionStorage.setItem(KEY, JSON.stringify(picked)); } catch (e) {} }
  function el(id) { return document.getElementById(id); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function find(id) { for (var i = 0; i < picked.length; i++) if (picked[i].id === id) return i; return -1; }

  function syncButtons() {
    document.querySelectorAll('.pmc-cmp').forEach(function (b) {
      var on = find(b.dataset.id) > -1;
      var label = on ? 'Comparing' : '+ Compare';
      if (b.getAttribute('aria-pressed') !== String(on)) b.setAttribute('aria-pressed', String(on));
      if (b.textContent !== label) b.textContent = label;
    });
  }

  function renderTray() {
    var tray = el('pmc-tray');
    if (!tray) return;
    el('pmc-tray-list').innerHTML = picked.map(function (p) {
      return '<span class="pmc-tray__item"><img src="' + esc(p.img) + '" alt=""><span>' + esc(p.title) + '</span><button type="button" data-remove="' + esc(p.id) + '" aria-label="Remove ' + esc(p.title) + '">&times;</button></span>';
    }).join('');
    el('pmc-tray-go').textContent = 'Compare ' + picked.length + (picked.length === 1 ? ' machine' : ' machines');
    el('pmc-tray-go').disabled = picked.length < 2;
    tray.classList.toggle('is-open', picked.length > 0);
    syncButtons();
  }

  function openModal() {
    var rows = [['Brand', 'vendor'], ['Wheels', 'wheels'], ['Speed', 'speed'], ['Ages', 'ages'], ['Price', 'price']];
    var head = '<thead><tr><td></td>' + picked.map(function (p) {
      return '<td><a href="' + esc(p.url) + '"><img src="' + esc(p.img) + '" alt=""><strong>' + esc(p.title) + '</strong></a></td>';
    }).join('') + '</tr></thead>';
    var body = '<tbody>' + rows.map(function (r) {
      return '<tr><th scope="row">' + r[0] + '</th>' + picked.map(function (p) { return '<td>' + esc(p[r[1]]) + '</td>'; }).join('') + '</tr>';
    }).join('') + '<tr><th></th>' + picked.map(function (p) {
      return '<td><a class="pmc-btn" href="' + esc(p.url) + '">View</a></td>';
    }).join('') + '</tr></tbody>';
    el('pmc-modal-body').innerHTML = '<table class="pmc-cmp-table">' + head + body + '</table>';
    el('pmc-modal').classList.add('is-open');
    el('pmc-modal-close').focus();
  }

  function closeModal() { var m = el('pmc-modal'); if (m) m.classList.remove('is-open'); }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('.pmc-cmp');
    if (b) {
      e.preventDefault();
      var i = find(b.dataset.id);
      if (i > -1) picked.splice(i, 1);
      else {
        if (picked.length >= MAX) picked.shift();
        var d = b.dataset;
        picked.push({ id: d.id, title: d.title, url: d.url, img: d.img, price: d.price, wheels: d.wheels, speed: d.speed, ages: d.ages, vendor: d.vendor });
      }
      save(); renderTray(); return;
    }
    var r = e.target.closest('[data-remove]');
    if (r) { var j = find(r.getAttribute('data-remove')); if (j > -1) picked.splice(j, 1); save(); renderTray(); return; }
    if (e.target.closest('#pmc-tray-clear')) { picked = []; save(); renderTray(); return; }
    if (e.target.closest('#pmc-tray-go')) { if (picked.length > 1) openModal(); return; }
    if (e.target.closest('#pmc-modal-close') || e.target.id === 'pmc-modal') closeModal();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

  // Focal swaps the product list after filtering/sorting/paging; re-sync the buttons when it does.
  var queued = false;
  function init() {
    renderTray();
    var grid = document.querySelector('.pmc-grid');
    if (!grid) return;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; syncButtons(); });
    }).observe(grid, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
